import { useEffect } from 'react'
import { HeroCollection } from '@pcln/hero-collection'
import type { IGoogleAnalyticsTrackingType } from '@pcln/contentful-components'
import { isIHeroCollection } from '@/shared-utils/content-model-type-guards'
import useContentfulVariation from '@/hooks/useContentfulVariation'
import analytics from '@/shared-utils/analytics'
import Head from 'next/head'

function handleHeroCollectionSelect(
  analyticsTracking: IGoogleAnalyticsTrackingType
) {
  if (analyticsTracking?.parameters) {
    analytics.fireGA4Event({
      event: 'select_promotion',
      attributes: {
        ...analyticsTracking?.parameters?.attributes
      }
    })
  }
}

export default function HeroCollectionWrapper() {
  const heroCollectionData = useContentfulVariation(
    'heroCollection',
    isIHeroCollection
  )
  useEffect(() => {
    const heroCollectionGA4params =
      heroCollectionData?.analyticsTracking?.parameters
    if (heroCollectionGA4params) {
      analytics.fireGA4Event({
        event: 'view_promotion',
        attributes: {
          ...heroCollectionGA4params?.attributes
        }
      })
    }
  }, [heroCollectionData])
  return (
    heroCollectionData && (
      <>
        <Head>
          {heroCollectionData?.heroImage?.asset?.file?.url && (
            <link
              rel="preload"
              as="image"
              fetchPriority="high"
              // TODO: This is temporary. The same params are hardcoded in the HeroCollection component.
              // This needs a permanent, shared solution.
              href={
                heroCollectionData.heroImage.asset.file.url +
                '?fm=webp&w=1232&q=90'
              }
            />
          )}
        </Head>
        <HeroCollection
          heroCollection={heroCollectionData}
          handleSelect={handleHeroCollectionSelect}
          overflowAllowancePxX={16}
        />
      </>
    )
  )
}
